import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon/Icon";
import Home from "@insite/mobius/Icons/Home";
import Link, { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    return {
        showPickUpLocation: state.context.session.fulfillmentMethod === FulfillmentMethod.PickUp,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        isAuthenticated: isAuthenticated,
    };
};

export interface LocationsStyles {
    locationWrapper?: InjectableCss;
    pickupLocation?: InjectableCss;
    locationText?: InjectableCss;
    locationLabel?: InjectableCss;
    locationIcon?: IconProps;
    locationInLink?: LinkPresentationProps;
}

export const locationStyles: LocationsStyles = {
    locationWrapper: {
        css: css`
            display: flex;
            gap: 6px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                        padding-bottom: 10px;
                    `,
                    css`
                        justify-content: center;
                        padding-bottom: 10px;
                    `,
                    css`
                        justify-content: flex-end;
                    `,
                    css`
                        justify-content: flex-end;
                    `,
                    css`
                        justify-content: flex-end;
                    `,
                ]);
            }}
        `,
    },
    pickupLocation: {
        css: css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            max-width: 200px;
        `,
    },
    locationText: {
        css: css`
            font-weight: bold;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 160px;
        `,
    },
    locationLabel: {
        css: css`
            max-width: 200px;
        `,
    },
    locationInLink: {
        icon: {
            iconProps: {
                size: 24,
                css: css`
                    margin-right: 5px;
                `,
            },
        },
        color: "black",
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export const HeaderPickUpLocation = ({ isAuthenticated, history, showPickUpLocation, pickUpWarehouse }: Props) => {
    const styles = locationStyles;

    if (!isAuthenticated || !showPickUpLocation || !pickUpWarehouse) {
        return null;
    }

    const changeCustomerClickHandler = () => {
        history.push("/MyAccount/ChangeCustomer");
    };

    return (
        <StyledWrapper {...styles.locationWrapper} className="locationWrapper">
            <Link
                {...styles.locationInLink}
                onClick={changeCustomerClickHandler}
                icon={{
                    ...styles.locationInLink?.icon,
                    iconProps: { src: Home, ...styles.locationInLink?.icon?.iconProps },
                }}
            >
                <StyledWrapper {...styles.pickupLocation}>
                    <Typography as="span" {...styles.locationLabel}>
                        {translate("Selected Pickup Location: ")}
                    </Typography>
                    <Typography as="span" {...styles.locationText}>
                        {pickUpWarehouse?.description}
                    </Typography>
                </StyledWrapper>
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(HeaderPickUpLocation)),
    definition: {
        displayName: "Pick Up Location",
        icon: "arrow-right-to-bracket",
        group: "Header",
    },
};

export default widgetModule;
